import React from "react";

import { TableCell, TableRow, Badge } from "@aws-amplify/ui-react";

function OrderLineItem({
  item,
  shipping_location,
}: {
  item: any;
  shipping_location?: string;
}) {
  const stockInfo = (
    qtyOrdered: number,
    inStock: number,
    stock_key: string
  ) => {
    if (inStock >= qtyOrdered) {
      return (
        <small style={{ color: "#ccc" }}>
          {stock_key.replace("_qty", "")}:
          <Badge size="small" variation="error">
            {inStock}
          </Badge>
        </small>
      );
    }
    return (
      <>
        <small style={{ color: "#ccc" }}>
          {stock_key.replace("_qty", "")}:
        </small>
        {inStock}
      </>
    );
  };

  const inventoryKeys = ['D11', 'D02', 'D07', 'D03', 'D06', 'D20'];

  return (
    <TableRow>
      <TableCell>
        <span style={{ color: "blue" }}>
          {item.variant_sku}: <Badge size="small">{item.barcode}</Badge>:{" "}
          <Badge size="small" variation="warning">
            {item.ordered_qty}
          </Badge>
        </span>
        <br />
        {item.product_name}
        {shipping_location && (
          <small style={{ color: "#ccc" }}>
            <br />
            {shipping_location}
          </small>
        )}
      </TableCell>
      {item.inventory &&
        inventoryKeys.map(
          (stock_key, index) =>
            stock_key !== "Id" && (
              <TableCell id={`stock_${stock_key}_${index}`} key={`stock_${stock_key}_${index}`}>
                {stockInfo(
                  item.ordered_qty,
                  item.inventory[`${stock_key}_qty`],
                  stock_key
                )}
              </TableCell>
            )
        )}
    </TableRow>
  );
}

export default OrderLineItem;
